var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.22 120.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.81,58.6H39.18C19.31,58.12,2.87,43.77.94,23.88L0,14.51A5.27,5.27,0,0,1,5.26,8.73H36ZM8.64,17.06l.58,6c1.53,15.71,14.49,26.83,30.16,27.2h.34L29.78,17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.09,58.6H75.41L90.19,8.73H121a5.28,5.28,0,0,1,5.24,5.78L125.08,26a30.38,30.38,0,0,1-5.22,14.14A40.08,40.08,0,0,1,86.09,58.6ZM96.44,17.06,86.5,50.27c10.73-.13,20.56-4.57,26.36-13.62a26,26,0,0,0,3.93-11.46l.79-8.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.95,
    y: 75.15,
    width: 18.17,
    height: 36.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.61,
    y: 91.1,
    width: 8.87,
    height: 49.88,
    rx: 4.43,
    transform: "translate(-53 179.08) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.76,0a2.62,2.62,0,0,1,2.62,2.62c0,40.16.12,40.41-.36,43.89a36.41,36.41,0,0,1-2.4,8.78C85.31,82.42,47.86,85.67,32.25,60.45a37.45,37.45,0,0,1-3.36-7,36.1,36.1,0,0,1-2.05-11.35V2.62A2.62,2.62,0,0,1,29.46,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.b1335cb980fc1a61a86c0b9862e01392.svg";
export { ForwardRef as ReactComponent };